import { writable } from 'svelte/store';
import { BranchContributorModel } from '../models/branchContributor.model';
import '../models/userInfo.model';
export const BranchContributors = writable([new BranchContributorModel()]);
